import { render } from "./CsvDownloadButton.vue?vue&type=template&id=4546c274"
import script from "./CsvDownloadButton.vue?vue&type=script&lang=ts"
export * from "./CsvDownloadButton.vue?vue&type=script&lang=ts"
script.render = render

export default script